import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class CapturumMissingTranslationHandler implements MissingTranslationHandler {
  public handle(params: MissingTranslationHandlerParams): string {
    return `[[ ${params.key} ]]`;
  }
}
